import React, { useEffect } from 'react'

import { useDispatch } from 'react-redux'
import { useRouteMatch } from 'react-router'

import { resetPhotoViewerAction } from 'actions/photo/photoViewerAction'
import { PhotoViewerCreateBaseUrl } from 'components/page/PhotoViewer/PhotoViewerCreateBaseUrl'
import { PhotoViewerDefault } from 'components/page/PhotoViewer/PhotoViewerDefault'
import { PhotoViewerModalWrapper } from 'components/page/PhotoViewer/PhotoViewerModalWrapper'

const PhotoViewerRoutes = () => {
  const match = useRouteMatch()
  const dispatch = useDispatch()
  useEffect(() => {
    return () => {
      dispatch(resetPhotoViewerAction())
    }
  }, [dispatch])

  if (match) {
    return (
      <PhotoViewerCreateBaseUrl>
        <PhotoViewerModalWrapper>
          <PhotoViewerDefault />
        </PhotoViewerModalWrapper>
      </PhotoViewerCreateBaseUrl>
    )
  }

  return null
}

export default PhotoViewerRoutes
